import { ReactComponent as NoRecord } from '../../assets/images/no-record.svg';
import { EmptyValue } from '../../features/clustering/client/helpers';
import { PropsWithChildren } from 'react';
import { Box, Flex, Text } from '@cdl/heartbeat-react';

type Props = PropsWithChildren<{
  message: EmptyValue;
  width: string | number;
  height: string | number;
}>;

export const EmptyContent: React.FC<Props> = ({
  message,
  width,
  height,
  children,
}) => {
  return (
    <Flex
      direction='column'
      width={width}
      height={height}
      align='center'
      justify='center'
    >
      <NoRecord />
      <Box textAlign='center' width='30vw'>
        <Text>{message.primary}</Text>
        <Text textStyle='category-subtitle' color='neutral.400'>
          {message.secondary}
        </Text>
      </Box>
      {children}
    </Flex>
  );
};
